import * as React from "react";
import ModalHeader from "../primitive/modal/ModalHeader2.primitive";
import ModalFooter2 from "../primitive/modal/ModalFooter2.primitive";
import { Modal } from "react-bootstrap";
function ModalLandingPageContact({
  onHide,
  show
}: {
  onHide: (value: void) => void;
  show: boolean;
}) {
  let headerModal = "Merci !";
  let bodyModalDebut = "Votre demande a été prise en compte.";
  let bodyModalFin = "Je vous contacterai dans les meilleurs délais.";
  return (
    <div>
      <Modal onHide={onHide} show={show} dialogClassName="modal-medgo is-landing">
        <ModalHeader label={headerModal} />
        <div>
          <p className="text-18 text-center modal-landing-body">{bodyModalDebut}</p>
          <p className="text-18 text-center modal-landing-body">{bodyModalFin}</p>

          <ModalFooter2
            buttons={[
              {
                label: "RETOUR À LA PAGE D'ACCUEIL",
                onClick: onHide
              }
            ]}
          />
        </div>
      </Modal>
      <div className="row">
        <div className="col-sm-12" />
      </div>
    </div>
  );
}

export default ModalLandingPageContact;



// WEBPACK FOOTER //
// ./assets/react/views/Landing/ModalLandingPageContact.view.tsx